export const EmployeeFrozenStatus = {
  NORMAL: 0,
  FREEZE: 1,
};
